import { styled } from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  column-gap: 8px;
  margin-top: 10px;
`;

export const MeasurementValue = styled.div<{
  isHighQuality?: boolean;
  isSmallText?: boolean;
}>`
  font-weight: 400;
  display: inline-block;
  white-space: break-spaces;
  color: ${props =>
    props.isHighQuality
      ? props.theme.colors.defaultTextColor
      : props.theme.colors.invidualDashboardCardLowQualityValue};
  font-size: ${props => (props.isSmallText ? '0.7rem' : '1.5rem')};
  margin-top: 40px;
  margin-bottom: 20px;
`;

export const StyledMeasurementCard = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 50px;
  width: 100%;
`;
